"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 20 20'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: 'currentColor',
    d: "M20,10 C20,4.47714844 15.5228516,0 10,0 C4.47714844,0 0,4.47714844 0,10 C0,14.9912891 3.656875,19.1283203 8.4375,19.8785156 L8.4375,12.890625 L5.8984375,12.890625 L5.8984375,10 L8.4375,10 L8.4375,7.796875 C8.4375,5.290625 9.93042969,3.90625 12.2146484,3.90625 C13.30875,3.90625 14.453125,4.1015625 14.453125,4.1015625 L14.453125,6.5625 L13.1921484,6.5625 C11.9499219,6.5625 11.5625,7.33332031 11.5625,8.12414062 L11.5625,10 L14.3359375,10 L13.8925781,12.890625 L11.5625,12.890625 L11.5625,19.8785156 C16.3431641,19.1283203 20,14.9912891 20,10 Z"
  }));
});